import { Component, DestroyRef, HostListener, ViewEncapsulation } from '@angular/core';
import { AuthService } from '@Services/auth.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SyncHubStatusService } from '@Core/services/sync-hub-status.service';
import { SyncStatus } from '@Core/enums/sync-status.enum';

@Component({
    standalone: false,
    selector: 'mgmt',
    templateUrl: './mgmt.component.html',
    styleUrls: ['./mgmt.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MgmtComponent {
    public loading = false;
    public isMainMenuOpen = false;

    // Consumed by the non-Aurora header only; the Aurora header sources this from AuroraHeaderDirective.
    public syncStatus: SyncStatus;

    constructor(public authService: AuthService,
        private router: Router,
        private destroyRef: DestroyRef,
        private syncStatusService: SyncHubStatusService) {
        const self = this;

        this.authService.spaName = 'mgmt';
        this.router.events.subscribe((event: Event) => {
            switch (true) {
                case event instanceof NavigationStart: {
                    setTimeout(() => self.loading = true);
                    break;
                }

                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError: {
                    setTimeout(() => self.loading = false);
                    break;
                }
                default: {
                    break;
                }
            }
        });

    }

    public ngOnInit(): void {
        this.syncStatusService.status
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((status: string) => {
                this.syncStatus = <SyncStatus>status;
            });
    }

    public toggleMainMenu(event: MouseEvent): void {
        event.stopPropagation();
        this.isMainMenuOpen = !this.isMainMenuOpen;
    }

    @HostListener('document:click')
    public closeMainMenu(): void {
        this.isMainMenuOpen = false;
    }
};
